import React from 'react'

import { UseFormReturn } from 'react-hook-form'

import { FormField } from '@/components/ui/form'
import { Input } from '@/components/ui/input'

import { FormFieldWrapper } from './FormFieldWrapper'

interface TextFieldProps {
  form: UseFormReturn<any>
  name: string
  label: string
  placeholder?: string
  tooltip?: string
  desc?: string
  type?: React.HTMLInputTypeAttribute
  disabled?: boolean
  required?: boolean
  autoComplete?: React.HTMLInputAutoCompleteAttribute
  className?: string
}

export function TextField({
  form,
  name,
  label,
  placeholder,
  tooltip,
  desc,
  type = 'text',
  disabled,
  required = false,
  autoComplete,
  className,
}: TextFieldProps) {
  const fieldState = form.getFieldState(name)

  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormFieldWrapper label={label} tooltip={tooltip} desc={desc} required={required}>
          <Input
            {...field}
            type={type}
            placeholder={placeholder}
            disabled={disabled}
            required={required}
            autoComplete={autoComplete}
            className={className}
            aria-invalid={!!fieldState.error}
            aria-required={required}
            value={(field.value as string | undefined | null) ?? ''}
          />
        </FormFieldWrapper>
      )}
    />
  )
}

// Memoized version for better performance
export const MemoizedTextField = React.memo(TextField) as typeof TextField
